module.exports = __webpack_public_path__ + "static/img/plan1.7496898.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/plans/zombs/plan1.png
// module id = D5PO
// module chunks = 35